import { render, staticRenderFns } from "./google.vue?vue&type=template&id=d9829c2e&"
import script from "./google.vue?vue&type=script&lang=js&"
export * from "./google.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9829c2e')) {
      api.createRecord('d9829c2e', component.options)
    } else {
      api.reload('d9829c2e', component.options)
    }
    module.hot.accept("./google.vue?vue&type=template&id=d9829c2e&", function () {
      api.rerender('d9829c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/google.vue"
export default component.exports